/**
 * Single source of truth for the operating LLC info.
 *
 * Replace [TO BE FILED] placeholders once the LLC is formed.
 * Backend mirrors these via env vars (see /app/backend/.env: PUBLIC_LLC_*).
 */
export const LLC = {
  name: "Corridor Digital LLC",
  short_name: "Corridor Digital",
  state: "New Mexico",
  registered_address_line_1: "1209 Mountain Road Pl NE, Ste N",
  registered_address_line_2: "Albuquerque, NM 87110, USA",
  contact_email: "legal@corridordigital.net",
  support_email: "support@corridordigital.net",
  founder_email: "derick@corridordigital.net",
  phone: "[TO BE FILED]", // e.g. "+1 (915) ..."
  ein: "42-2467359",
  duns: "[TO BE FILED]",
  // ISO format YYYY-MM-DD — bump when you materially change any legal doc
  legal_effective_date: "2026-02-11",
  // Show this in light text where the LLC is not yet formed
  pending_label: "Pending entity formation · " + new Date().getFullYear(),
};

export const isLLCFormed = true;
